"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzonePreviewAction = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const DropzonePreviewAction = ({ icon, onClick, ariaLabel, className, }) => {
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, "aria-label": ariaLabel, className: (0, classnames_1.default)("dropzone-preview-action", className) }, icon));
};
exports.DropzonePreviewAction = DropzonePreviewAction;
//# sourceMappingURL=DropzonePreviewAction.js.map